/**
 * DrewCore Floating Phone CTA.
 *
 * Felelősség:
 *   - Mobil sticky bar (.floating-cta__mobile) megjelenítése 500px scroll után
 *     a wrapperre tett `.is-visible` class-szal.
 *   - Body padding-bottom: 70px dinamikus alkalmazása mobil viewporton,
 *     amíg a sticky bar látszik. Asztali viewporton soha nincs body padding.
 *   - Resize (mobil ↔ asztal) kezelése: paddingot le-, ill. visszateszi.
 *
 * Az asztali kör ikon CSS-only (folyamatosan látszik, semmi JS nem kell).
 *
 * HTML hook: [data-floating-cta] -- a komponens wrapper.
 * Mobil bar elrejtése overlay nyitva állapotban: CSS (body.dc-menu-locked).
 */

(function () {
  'use strict';

  var floatingCta = document.querySelector('[data-floating-cta]');
  if (!floatingCta) return;

  var SCROLL_THRESHOLD = 500;
  var MOBILE_BAR_HEIGHT = 70;
  var MOBILE_MQ = '(max-width: 991.98px)';

  var scrollTicking = false;
  var bodyPaddingApplied = false;
  var isVisible = false;

  function applyBodyPadding() {
    if (bodyPaddingApplied) return;
    document.body.style.paddingBottom = MOBILE_BAR_HEIGHT + 'px';
    bodyPaddingApplied = true;
  }

  function removeBodyPadding() {
    if (!bodyPaddingApplied) return;
    document.body.style.paddingBottom = '';
    bodyPaddingApplied = false;
  }

  function updateVisibility() {
    if (scrollTicking) return;
    scrollTicking = true;

    window.requestAnimationFrame(function () {
      var shouldShow = window.scrollY > SCROLL_THRESHOLD;
      var isMobile   = window.matchMedia(MOBILE_MQ).matches;

      if (shouldShow !== isVisible) {
        if (shouldShow) {
          floatingCta.classList.add('is-visible');
        } else {
          floatingCta.classList.remove('is-visible');
        }
        isVisible = shouldShow;
      }

      /* Body padding-bottom csak mobilon és csak amíg a bar látszik */
      if (isMobile && shouldShow) {
        applyBodyPadding();
      } else {
        removeBodyPadding();
      }

      scrollTicking = false;
    });
  }

  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();

  /* Resize handler: bp átlépésekor a padding-szabályt újraértékeljük */
  var mql = window.matchMedia(MOBILE_MQ);
  var onMqlChange = function (e) {
    if (e.matches) {
      /* → mobil */
      if (isVisible) applyBodyPadding();
    } else {
      /* → asztal */
      removeBodyPadding();
    }
  };
  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', onMqlChange);
  } else if (typeof mql.addListener === 'function') {
    mql.addListener(onMqlChange);
  }

})();
